import { render } from "./AppDrawer.vue?vue&type=template&id=aaccf2e8&scoped=true"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"

import "./AppDrawer.vue?vue&type=style&index=0&id=aaccf2e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaccf2e8"]])

export default __exports__